import type { PageLoad } from './$types';

export const load = (async ({ data }) => {
	return {
		...data,
		title: data.author.name,
		description: `Read the latest articles written by ${data.author.name} on GrowBeansprout. ${data.author.biography}`,
		breadcrumbs: [{ title: data.author.name }]
	};
}) satisfies PageLoad;
